import { render, staticRenderFns } from "./PrivacyDocScan.vue?vue&type=template&id=4429243b&scoped=true"
import script from "./PrivacyDocScan.vue?vue&type=script&lang=js"
export * from "./PrivacyDocScan.vue?vue&type=script&lang=js"
import style0 from "./PrivacyDocScan.vue?vue&type=style&index=0&id=4429243b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4429243b",
  null
  
)

export default component.exports